import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import { Text as Base } from "@cancer-council-queensland/react";
import React from "react";
import { render, NODE_PARAGRAPH, MARK_LINK } from "storyblok-rich-text-react-renderer";
import { Components } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Text = _ref => {
  var {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_jsx(Base, _extends({}, rest, {
    children: render(children, {
      blokResolvers: Components,
      nodeResolvers: {
        [NODE_PARAGRAPH]: children => {
          if (React.Children.toArray(children).some( // @ts-ignore
          child => {
            var _child$props, _child$props$classNam;

            return child == null ? void 0 : (_child$props = child.props) == null ? void 0 : (_child$props$classNam = _child$props.className) == null ? void 0 : _child$props$classNam.includes("inline");
          })) {
            return /*#__PURE__*/_jsx("p", {
              className: "inline",
              children: children
            });
          }

          return /*#__PURE__*/_jsx("p", {
            children: children
          });
        }
      },
      markResolvers: {
        [MARK_LINK]: (children, props) => {
          var {
            href,
            target,
            linktype
          } = props;

          if (linktype === 'url' && href && href.indexOf('http') === 0) {
            return /*#__PURE__*/_jsxs("a", {
              rel: "noreferrer",
              href: href,
              target: "_blank",
              className: "relative underline font-bold mr-3",
              children: [/*#__PURE__*/_jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: "h-4 w-4 absolute -right-3 -top-2",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: [/*#__PURE__*/_jsx("path", {
                  d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
                }), /*#__PURE__*/_jsx("path", {
                  d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
                })]
              }), /*#__PURE__*/_jsx(_Fragment, {
                children: children
              }), /*#__PURE__*/_jsx("span", {
                className: "sr-only",
                children: "(opens in new tab)"
              })]
            });
          } else {
            return /*#__PURE__*/_jsx("a", {
              href: href,
              target: target,
              children: children
            });
          }
        }
      }
    })
  }));
};
//# sourceMappingURL=text.js.map